import React from 'react';
import { useSelector } from 'shared/node_modules/react-redux';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import { dailyWheelCollectButtonFontSizeCalc } from 'shared/utils/fontSizeCalculator';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { useTheme } from 'styled-components';
import Button from '../../../../components/Button/Button';
import ImageBW from '../../../../components/ImageBoundsWrapper';
import {
  BottomBarBackgroundWrapper,
  BottomBarBackgroundWrapperImage,
  BottomBarContainer,
  BottomBarRightPlusText,
  BottomBarRightSideBottomText,
  BottomBarStyles,
  BottomRightCoinImage,
  BottomRightContentWrapper,
  BottomRightItemsText,
  BottomRightLoyaltyImage,
  BottomRightSideContainer,
  BottomTotalBonusImage,
  BottomTotalBonusWrapper,
} from '../styledComponents';
import BottomBarLeftSide from './LeftSide';

export default function BottomBar(props) {
  const themeContext = useTheme();
  const dailyWheelCard = useSelector(state => state.properties.data.dailyWheelCard);
  const dailyWheelAssets = useSelector(state => state.assetsPackage.assets.DAILY_WHEEL);
  const assetsUrls = useSelector(state => state.app.assetsUrls);

  const {
    bottomBarAnimDeg,
    wheelBonus,
    dailyBonus,
    isPhysicallyVerified,
    linkedAccount,
    currentTierBonus,
    showTotalCoins,
    totalCoinsAfterTierBonus,
    totalLoyalty,
    showTotalLoyalty,
    nextStepHandler,
    isLoading,
    enableLoyalty,
    loyaltyCardComingSoon,
    step,
  } = props;

  const showLoyaltyPart = showTotalLoyalty && enableLoyalty;
  const cardIconPath = dailyWheelCard && linkedAccount ? assetsUrls.ImagesCdnBaseUrl + '/' + dailyWheelCard : null;

  return (
    <BottomBarContainer
      theme={themeContext.DailySpin.BottomBar}
      style={{
        transform: [
          {
            translateY: bottomBarAnimDeg,
          },
        ],
      }}
    >
      <BottomBarBackgroundWrapper>
        <BottomBarBackgroundWrapperImage
          theme={themeContext.DailySpin.BottomBarBackgroundWrapperImage}
          src={dailyWheelAssets.DAILY_SPIN_BOTTOM_BACKGROUND}
        />
        <div style={themeContext.DailySpin.BottomBarContainer}>
          <BottomBarLeftSide
            dailyWheelAssets={dailyWheelAssets}
            step={step}
            wheelBonus={wheelBonus}
            dailyBonus={dailyBonus}
            linkedAccount={linkedAccount}
            currentTierBonus={currentTierBonus}
            cardIconPath={cardIconPath}
            loyaltyCardComingSoon={loyaltyCardComingSoon}
          />
          <BottomRightSideContainer>
            <ImageBW
              source={dailyWheelAssets.DAILY_SPIN_BOTTOM_BOX}
              ibw={require(asset`images/daily-spin/bottom-inset.ibw`)}
              style={BottomBarStyles.bottomRightWrapper}
              innerStyle={BottomBarStyles.bottomRightWrapperInner}
              imageStyle={themeContext.DailySpin.BottomInsetImage}
            >
              <BottomRightContentWrapper>
                <BottomTotalBonusWrapper>
                  <BottomTotalBonusImage src={dailyWheelAssets.DAILY_SPIN_TEXT_TOTAL} alt="TOTAL BONUS" />
                </BottomTotalBonusWrapper>
                {showTotalCoins && (
                  <div
                    className={`${
                      step === 2
                        ? isPhysicallyVerified
                          ? 'TotalBonusAnimationVerified'
                          : 'TotalBonusAnimationNotVerified'
                        : 'TotalBonusSmall'
                    }`}
                  >
                    <BottomRightCoinImage
                      theme={themeContext.DailySpin.BottomRightCoinImage}
                      src={icons.coin}
                      alt="Currency"
                    />
                    <BottomRightItemsText data-label={totalCoinsAfterTierBonus}>
                      {totalCoinsAfterTierBonus}
                    </BottomRightItemsText>
                  </div>
                )}
                {showTotalCoins && showLoyaltyPart && (
                  <BottomBarRightPlusText>{getText(TEXT_KEY.PLUS_SYMBOL)}</BottomBarRightPlusText>
                )}
                {showLoyaltyPart && (
                  <div
                    className={`${
                      step === 2
                        ? isPhysicallyVerified
                          ? 'TotalBonusAnimationVerified'
                          : 'TotalBonusAnimationNotVerified'
                        : 'TotalBonusSmall'
                    }`}
                  >
                    <BottomRightLoyaltyImage src={icons.loyalty} alt="Loyalty" />
                    <BottomRightItemsText left={'0px'} data-label={totalLoyalty}>
                      {totalLoyalty}
                    </BottomRightItemsText>
                  </div>
                )}
              </BottomRightContentWrapper>
              <Button
                imageSource={
                  !isLoading
                    ? assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)
                    : assetSource(ASSET_KEY.ROUNDED_RECT_DISABLED)
                }
                label={getText(TEXT_KEY.COLLECT_BUTTON)}
                isDebounce={true}
                textStyle={{
                  ...themeContext.DailySpin.DailyWheelCollectButton,
                  ...dailyWheelCollectButtonFontSizeCalc(getText(TEXT_KEY.COLLECT_BUTTON)),
                }}
                containerStyle={BottomBarStyles.bottomCollectButtonContainer}
                imageStyle={BottomBarStyles.bottomCollectButton}
                disabled={isLoading}
                onClick={() => nextStepHandler(1)}
                textStroke={BUTTON_STROKES.PRIMARY}
              />
            </ImageBW>
            <BottomBarRightSideBottomText
              theme={themeContext.DailySpin.BottomBarBottomText}
              src={dailyWheelAssets.DAILY_SPIN_TEXT_LOGIN}
            />
          </BottomRightSideContainer>
        </div>
      </BottomBarBackgroundWrapper>
    </BottomBarContainer>
  );
}

const icons = {
  coin: assetSource(ASSET_KEY.COIN_ICON),
  loyalty: assetSource(ASSET_KEY.LOYALTY_ICON),
};

